import { SpecTest } from '@signifyd/cypress'

export const getTraceFileForTestAttachments = (
  attachments?: Array<string>
): string | undefined => {
  const traceAttachment = attachments?.find((attachment) =>
    attachment.endsWith('.zip')
  )

  return traceAttachment?.split('/').pop()
}

/**
 * Gets the raw <trace.zip> from the test's attachment paths
 */
export const getTraceFileForTest = (test: SpecTest): string | undefined => {
  return getTraceFileForTestAttachments(test.attachments)
}
